import moment from "jalali-moment";
import { useEffect, useRef } from "react";


const ClientMessage = ({ message, response, createdAt }) => {
    const chatContainerRef = useRef(null);  // ایجاد ref برای دسترسی به container
    useEffect(() => {
        // اسکرول به پایین بعد از هر رندر
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }, [message, response]);


    const buttons = [
        {
            key: 'bookmark',
            svg: (
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17 3H7c-1.1 0-2 .9-2 2v14l7-3 7 3V5c0-1.1-.9-2-2-2z"></path>
                </svg>
            ),
        },
        {
            key: 'edit',
            svg: (
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 32 32">
                    <path d="M 23.90625 3.96875 C 22.859375 3.96875 21.8125 4.375 21 5.1875 L 5.1875 21 L 5.125 21.3125 L 4.03125 26.8125 L 3.71875 28.28125 L 5.1875 27.96875 L 10.6875 26.875 L 11 26.8125 L 26.8125 11 C 28.4375 9.375 28.4375 6.8125 26.8125 5.1875 C 26 4.375 24.953125 3.96875 23.90625 3.96875 Z M 23.90625 5.875 C 24.410156 5.875 24.917969 6.105469 25.40625 6.59375 C 26.378906 7.566406 26.378906 8.621094 25.40625 9.59375 L 24.6875 10.28125 L 21.71875 7.3125 L 22.40625 6.59375 C 22.894531 6.105469 23.402344 5.875 23.90625 5.875 Z M 20.3125 8.71875 L 23.28125 11.6875 L 11.1875 23.78125 C 10.53125 22.5 9.5 21.46875 8.21875 20.8125 Z M 6.9375 22.4375 C 8.136719 22.921875 9.078125 23.863281 9.5625 25.0625 L 6.28125 25.71875 Z"></path>
                </svg>
            ),
        },
        {
            key: 'heart',
            svg: (
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path>
                </svg>
            ),
        }
    ];

    return (
        <div ref={chatContainerRef}>
            {message != "" && (<>
                <li className={"flex justify-start ml-5 mb-1.5"}>
                    <div
                        className={`inline-block px-5 py-3 rounded-lg bg-[#aadec5] text-gary-800  dark:bg-zinc-700 dark:text-gray-100'}`}
                    >
                        <div className="flex justify-end gap-1 text-gray-500 mb-1">
                            <span className="inline-flex  items-center justify-end fix left-0 rounded-mdpx-2 py-1 text-xs font-light text-gray-600 ">
                                {/* {moment(createdAt).locale('fa').format('YYYY/MM/DD HH:mm:ss')} */}
                                {moment.utc(createdAt)
                                .local()
                                .locale('fa')
                                .format('YYYY/MM/DD HH:mm:ss')}
                            </span>
                        </div>
                        <p className="font-medium">{message}</p>
                    </div>
                </li>
                <div className={"flex justify-start ml-5  gap-1 text-gray-500 mb-4"}>
                    {buttons.map(({ key, svg }) => (
                        <button key={key} className={"text-[#aadec5] hover:text-[#1B4748]"}>
                            {svg}
                        </button>
                    ))}
                </div>
            </>)}
            <li className="flex justify-end mr-5 mb-1.5">
                <div
                    className={"inline-block px-5 py-3 rounded-lg  bg-gray-50 dark:bg-zinc-700 text-gray-700 dark:text-gray-100"}
                >
                    <div className="flex justify-end gap-1 text-gray-500 mb-1">
                        <span className="inline-flex  items-center justify-end fix left-0 rounded-mdpx-2 py-1 text-xs font-light text-gray-600 ">
                            {/* {moment(createdAt).locale('fa').format('YYYY/MM/DD HH:mm:ss')} */}
                            {moment.utc(createdAt)
                                .local()
                                .locale('fa')
                                .format('YYYY/MM/DD HH:mm:ss')}
                        </span>
                    </div>
                    <p className="font-medium">{response}</p>
                </div>
            </li>

            <div className={"flex justify-end mr-5 gap-1 text-gray-500 mb-4"}>
                {[...buttons].reverse().map(({ key, svg }) => (
                    <button key={key} className={"text-gray-450 hover:text-[#1B4748]"}>
                        {svg}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default ClientMessage;
